import React from 'react'
import selectors from '../../store/selectors'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import * as actions from '../../store/actions'
import styled from 'styled-components'
import { FaListAlt } from 'react-icons/fa'
import { FULLSCEEN_WIDTH_BREAKPOINT } from 'src/constants'


const Button = ({ toggle, items }) => {
  if (items.size === 0) { return null }

  return (
    <StyledButton onClick={toggle} title="Table of contents">
      <FaListAlt/>
    </StyledButton>
  )
}

const StyledButton = styled.button`
  color: ${props => props.theme.primaryColor};
  background: none;
  border: 0px solid;
  cursor: pointer;
  outline: 0;
  font-size: 26px;

  @media screen and (max-width: ${FULLSCEEN_WIDTH_BREAKPOINT}px) {
    display: none;
  }
`

const mapStateToProps = createStructuredSelector({
  enabled: selectors.selectShowTOC,
  items: selectors.selectTocItems
})

const mapDispatchToProps = dispatch => ({
  toggle: () => dispatch(actions.toggleTOC())
})


export default connect(mapStateToProps, mapDispatchToProps)(Button)



// WEBPACK FOOTER //
// ./src/ChatWidget/components/TableOfContents/Button.js